import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ToasterService } from './toaster.service';

@Component({
  selector: 'app-toaster',
  imports: [MatIconModule],
  templateUrl: './toaster.html',
  styleUrl: './toaster.scss',
})
export class Toaster {
  readonly toasterService = inject(ToasterService);
}
